import { useContext } from 'react';
import { IModuleContext, ModuleContext } from '../ModuleContext';

export const useModule = () => {
	const context = useContext(ModuleContext);
	if (context === undefined) {
		return {} as IModuleContext;
	}
	return context;
};
